{
  "sequence": [
    { "pitch": 36, "onset": 0, "duration": 1 },
    { "pitch": 42, "onset": 0, "duration": 1 },
    { "pitch": 42, "onset": 2, "duration": 1 },
    { "pitch": 42, "onset": 4, "duration": 1 },
    { "pitch": 38, "onset": 4, "duration": 1 },
    { "pitch": 42, "onset": 6, "duration": 1 },
    { "pitch": 42, "onset": 8, "duration": 1 },
    { "pitch": 42, "onset": 10, "duration": 1 },
    { "pitch": 36, "onset": 10, "duration": 1 },
    { "pitch": 42, "onset": 12, "duration": 1 },
    { "pitch": 38, "onset": 12, "duration": 1 },
    { "pitch": 36, "onset": 2, "duration": 1 },
    { "pitch": 36, "onset": 8, "duration": 1 },
    { "pitch": 42, "onset": 14, "duration": 1 },
    { "pitch": 38, "onset": 15, "duration": 1 }
  ],
  "length": 16,
  "_metadata": {
    "instrumentType": "groovebox"
  }
}